import React, { Component } from 'react'
import $ from 'jquery'

import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import {
    addModal,
    popModal
} from '../../../actions/appAction'

import {
    translate
} from 'react-switch-lang'

export class ForgotPasswordModal extends Component {

    constructor(){
        super();
        this.state = {
            emailAddress : "",
            emailInvalid : false,
            modalZ : 1050
        }
    }

    componentDidMount(){
       
        const { isOpened } = this.props;
        
        if(isOpened){
            $('#forgotPasswordModal').modal({backdrop:'static', keyboard:false});
            $('#forgotPasswordModal .modal-dialog').attr('class','modal-dialog modal-dialog-centered slideInDown animated')
            $('#forgotPasswordModal').modal('show');
            if(this.props.addModal){
                this.props.addModal('forgot-password-modal')
            }
            $('.modal-backdrop').eq($('.modal-backdrop').length-1).addClass("fpp-bd");
        }

    }

    componentDidUpdate(prevProps){
        if(prevProps.modalInstances!==this.props.modalInstances){
            let modalInstance = this.props.modalInstances.find( (data) => data.modal_class==="forgot-password-modal");
            if(modalInstance!==undefined){
                $('.fpp-bd').css('z-index',`${modalInstance.z_index-10}`)
                this.setState({
                    modalZ : modalInstance.z_index
                })
            }
        }
    }

    componentWillUnmount(){
        $('#forgotPasswordModal').modal('hide');
        if(this.props.popModal){
            this.props.popModal()
        }
        $('body').removeClass('modal-open');
    }

    onInputChange = (e) => {

        const { t, currentLanguage } = this.props;

        let regExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i;
        let emailVal = e.target.value;

        $('#emailAddress').removeClass('error-input');
        $('#emailAddress').removeClass('success-input');
        $('#emailAddress').next('.error-input-message').text('');
        $('#emailAddress').next('.success-input-message').text('');
        $('#emailAddress').next().next().text('');

        if(e.target.value.length===0){
            return
        }

        if(!regExp.test(emailVal)){
            $('#emailAddress').addClass('error-input');
            $('#emailAddress').next('.error-input-message').text(t('login_message_incorrect_email'));
            
            this.setState({
                emailInvalid : true,
                emailAddress : ""
            })
        }else{
            this.setState({
                emailInvalid : false,
                emailAddress : e.target.value
            })
        }
    }

    sendForgotPasswordLink = () => {

        const { emailInvalid, emailAddress } = this.state;

        if( emailAddress === "" ){
            $('#emailAddress').addClass('error-input');
            this.setState({
                emailInvalid : true
            })
        }else{
            if(!emailInvalid){
                this.props.sendForgotPasswordLink({
                    emailAddress : emailAddress
                })
            }
        }

        
    }

    render(){
        const { emailAddress, modalZ } = this.state;
        const { forgotPasswordModalError } = this.props;

        const { isMobileView } = this.props;
        const { t, currentLanguage } = this.props;

        let modalDialogClass = isMobileView ? "mobile-modal" : "" 

        return (
            <div style={{ zIndex : `${modalZ}` }} className={`${modalDialogClass} forgot-password-modal modal fade modal-opaque`} id="forgotPasswordModal" tabIndex="-1" role="dialog" aria-labelledby="forgotPasswordModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {
                            isMobileView ?
                            <div className="mobile-custom-header modal-header">
                                <div className="row" style={{ width: "100%" }}>
                                    <div className="col" style={{ textAlign : "left" }}>
                                        <img style={{ display: "block", width: "150px" }} src={require('../../../images/tarjemle-logo.png')}/>
                                    </div>
                                    <div className="col" style={{ textAlign : "right", paddingRight : "0" }}>
                                        <button onClick={this.props.closeforgotPasswordModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span className="close-modal-btn" aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="custom-modal-header modal-header">
                                <button onClick={this.props.closeforgotPasswordModal} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span style={{ fontWeight: "300", fontSize: "70px" }} aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        }
                        
                        <div className="modal-body">
                            <p className="text-header">{t('forgot_pass_modal_header')}</p>
                            
                            <div className="form-group mt-4">
                                <input onChange={this.onInputChange} id="emailAddress" name="emailAddress" style={{ width: "100%" }} className="custom-input" type="text" placeholder={t('common_enter_email_here')}/>
                                <span className="error-input-message">{forgotPasswordModalError}</span>
                                <span class="success-input-message"></span>
                            </div>

                            <div className="text-center">
                                <button onClick={this.sendForgotPasswordLink} style={{ width: "192px" , border :"none", background : "#22C9C7", borderRadius : "8px", padding: "16px 20px", fontSize : "16px", fontWeight : "bold", textTransform : "uppercase", textAlign : "center", color : "#FAFAFA", marginTop : "30px" }}>{t('common_confirm')}</button>    
                            </div>                            
                        </div>
                    
                    </div>
                </div>
            </div>
            
        )

    }

}

const mapStateToProps = state => {
    return {
        modalInstances : state.app.modalInstances,
        isMobileView : state.app.isMobileView
    }
}

export default compose(
    withRouter,
    translate,
    connect(mapStateToProps, { 
        addModal,
        popModal
    })
)(ForgotPasswordModal)